enum PlatformType {
    ALL = 'all',
    ANDROID = 'android',
    WINDOWS = 'windows',
    MACOS = 'macos',
    LINUX = 'linux',
}

export default PlatformType
